import React from "react";
import TableView from "../tables/TableView";
import useTableData from "./useTableData";
import SubList from "./_support/SubList";
import TableInput from "../forms/formElements/TableInput";
import TableInputRow from "../forms/formElements/TableInputRow";
import StringInput from "../forms/formElements/StringInput";
import BooleanInput from "../forms/formElements/BooleanInput";
import ComboBox from "../forms/formElements/ComboBox";

const headers = ['Meno', 'Telefón', 'Pevná linka', 'Mail', 'Oddelenie']

function Contacts(props) {
    let data = [...props.data['Kontakt'], {
        'Meno': '',
        'Telefon': '',
        'Pevna_Linka': '',
        'Mail': '',
        'Oddelenie': ''
    }]
    return (
        <SubList label="Kontakty">
            <TableInput headers={headers} delete={props.delete}>
                {data.map((item, index) => (
                    <TableInputRow delete={index === data.length - 1 ? null : props.delete} ndx={index} index={0}>
                        <StringInput name={'Meno'}
                                     value={item.Meno}
                                     onChange={event => props.updateContact(event, index)}/>
                        <StringInput name={'Telefon'}
                                     value={item.Telefon}
                                     onChange={event => props.updateContact(event, index)}/>
                        <StringInput name={'Pevná linka'}
                                     value={item.Pevna_Linka}
                                     onChange={event => props.updateContact(event, index)}/>
                        <StringInput name={'Mail'}
                                     value={item.Mail}
                                     onChange={event => props.updateContact(event, index)}/>
                        <StringInput name={'Oddelenie'}
                                     value={item.Oddelenie}
                                     onChange={event => props.updateContact(event, index)}/>
                    </TableInputRow>
                ))
                }
            </TableInput>
        </SubList>
    )
}

export default Contacts
